import { NgClass } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { ProposalScope } from "@app/core/domain/proposal-status";
import { SubmitProposalStateService } from "@app/features/submit-proposal/services/submit-proposal-state.service";
import { AddCourseListHeaderComponent } from "@app/shared/components/add-course-list-header/add-course-list-header.component";
import { AddCourseListItemComponent } from "@app/shared/components/add-course-list-item/add-course-list-item.component";
import { CourseItemComponent } from "@app/shared/components/course-item/course-item.component";
import { CourseDataMapper } from "@app/shared/services/course-data-mapping.service";
import {
  ConfirmCourseListBuilder,
  SelectedCourseGroup,
} from "@feature/submit-proposal/services/confirm-course-list.builder";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { SubmitCourseGroup } from "../../services/choice-course-list.builder";

@Component({
  selector: "pa-submit-proposal-right-confirm",
  templateUrl: "./submit-proposal-right-confirm.component.html",
  styleUrls: ["./submit-proposal-right-confirm.component.scss"],
  standalone: true,
  imports: [AddCourseListHeaderComponent, AddCourseListItemComponent, CourseItemComponent, NgClass, TranslatePipe],
})
export class SubmitProposalRightConfirmComponent {
  private readonly submitProposalStateService = inject(SubmitProposalStateService);
  private readonly courseDataMapper = inject(CourseDataMapper);
  private readonly translate = inject(TranslateService);

  submitInfo = this.submitProposalStateService.submitInfo;

  submitWholeProgram = computed<boolean>(() => {
    return this.submitInfo()?.proposalScope === ProposalScope.WHOLE_PROGRAM;
  });

  selectedElectivesCourseGroups = computed<SelectedCourseGroup[]>(() => {
    const submitInfo = this.submitInfo();
    return submitInfo ? this.confirmCourseListBuilder.buildElectivesCourseGroups(submitInfo) : [];
  });

  otherCourseGroups = computed<SubmitCourseGroup[]>(() => {
    this.submitProposalStateService.submitInfo(); // Triggers the effect...
    return this.submitProposalStateService.otherCourseGroups;
  });

  private readonly confirmCourseListBuilder: ConfirmCourseListBuilder;

  constructor() {
    this.confirmCourseListBuilder = new ConfirmCourseListBuilder(
      this.translate,
      this.courseDataMapper,
      this.submitProposalStateService,
    );
  }
}
